export class LicenceSchool {
    constructor(
        public id?: number,
        public academicRegionLabel?: string,
        public academyCode?: string,
        public academyLabel?: string,
        public schoolUai?: string,
        public schoolLabel?: string,
        public createdBy?: string,
        public createdDate?: string,
        public lastModifiedBy?: string,
        public lastModifiedDate?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/licence-school/licence-school.model.ts